import React, { useEffect, useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const ConfirmationModal = ({ bookingData, settings, onComplete }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animation beim Einblenden
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onComplete, 300); // Nach Animation schließen
  };

  return (
    <>
      {/* Backdrop mit Animation */}
      <div 
        className={`fixed inset-0 bg-black transition-opacity duration-300 z-40 ${
          isVisible ? 'bg-opacity-50' : 'bg-opacity-0'
        }`}
        onClick={handleClose}
      />
      
      {/* Modal */}
      <div className="fixed inset-0 flex items-center justify-center p-4 z-50">
        <div className={`bg-white rounded-2xl border-4 border-gray-400 max-w-md w-full transform transition-all duration-300 ${
          isVisible ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
        }`}>
          
          {/* Header mit Close Button */}
          <div className="relative p-8">
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 transition-colors rounded-full hover:bg-gray-100"
            >
              <XMarkIcon className="w-6 h-6" />
            </button>
            
            {/* Vereinfachter Inhalt */}
            <div className="text-center">
              <div className="flex justify-center mb-6">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center animate-pulse">
                  <span className="text-4xl">📧</span>
                </div>
              </div>
              
              <h2 className="text-2xl font-bold mb-4 text-blue-600">
                Reservierungsanfrage erhalten! 
              </h2>
              
              <p className="text-gray-600 text-lg leading-relaxed mb-8">
                Wir haben Ihre Anfrage erhalten und prüfen die Verfügbarkeit. <strong>Die Reservierung ist erst nach unserer Bestätigung verbindlich.</strong> Sie erhalten in Kürze eine E-Mail mit weiteren Informationen.
              </p>

              {/* Action Button */}
              <button
                onClick={handleClose}
                className="w-full px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-all duration-200 font-semibold text-lg transform hover:-translate-y-0.5 border-2 border-blue-600"
              >
                Verstanden
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal; 